import React from 'react';

const Jobs = () => {
  const jobs = [
    {
      id: 1,
      title: 'Senior Full Stack Developer',
      location: 'Nashik / Remote',
      type: 'Full-time',
      experience: '5+ years exp',
      description: "We're seeking an experienced Full Stack Developer proficient in React, Node.js, and cloud technologies. You'll lead development of enterprise applications and mentor junior developers.",
      tags: ['React', 'Node.js', 'AWS', 'MongoDB']
    },
    {
      id: 2,
      title: 'React Native Developer',
      location: 'Nashik / Remote',
      type: 'Full-time',
      experience: '3+ years exp',
      description: 'Join our mobile team to build beautiful, performant cross-platform applications. Experience with React Native, TypeScript, and mobile UI/UX principles required.',
      tags: ['React Native', 'TypeScript', 'iOS', 'Android']
    },
    {
      id: 3,
      title: 'AI/ML Engineer',
      location: 'Nashik / Remote',
      type: 'Full-time',
      experience: '4+ years exp',
      description: "Help us build intelligent systems using machine learning and AI. You'll work on NLP, computer vision, and predictive analytics projects for diverse clients.",
      tags: ['Python', 'TensorFlow', 'PyTorch', 'NLP']
    },
    {
      id: 4,
      title: 'DevOps Engineer',
      location: 'Nashik / Remote',
      type: 'Full-time',
      experience: '3+ years exp',
      description: 'Build and maintain CI/CD pipelines, manage cloud infrastructure on AWS, and ensure system reliability. Experience with Docker, Kubernetes, and infrastructure as code essential.',
      tags: ['AWS', 'Docker', 'Kubernetes', 'Terraform']
    },
    {
      id: 5,
      title: 'UI/UX Designer',
      location: 'Nashik / Remote',
      type: 'Full-time',
      experience: '3+ years exp',
      description: "Create beautiful, intuitive interfaces for web and mobile applications. You'll work closely with developers to bring designs to life and enhance user experiences.",
      tags: ['Figma', 'Adobe XD', 'Prototyping', 'User Research']
    },
    {
      id: 6,
      title: 'Junior Developer (Multiple Positions)',
      location: 'Nashik',
      type: 'Full-time',
      experience: '0-2 years exp',
      description: 'Start your career with us! We\'re hiring fresh graduates and junior developers passionate about web/mobile development. Great learning opportunities and mentorship provided.',
      tags: ['JavaScript', 'React', 'Node.js', 'Willing to Learn']
    }
  ];

  return (
    <div className="page-content active">
      <section className="hero" style={{ minHeight: '400px' }}>
        <div className="hero-container" style={{ gridTemplateColumns: '1fr' }}>
          <div className="hero-content" style={{ textAlign: 'center' }}>
            <h1>Join Our <span className="highlight">Team</span></h1>
            <p>Build your career with a company that values innovation, growth, and collaboration</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-header">
          <div className="label">Open Positions</div>
          <h2>Current Opportunities</h2>
          <p>We're looking for talented individuals who are passionate about technology</p>
        </div>
        
        <div className="jobs-grid">
          {jobs.map((job) => (
            <div key={job.id} className="job-card">
              <div className="job-info">
                <h3>{job.title}</h3>
                <div className="job-meta">
                  <span>📍 {job.location}</span>
                  <span>⏰ {job.type}</span>
                  <span>💼 {job.experience}</span>
                </div>
                <p className="job-description">{job.description}</p>
                <div className="tech-tags">
                  {job.tags.map((tag, index) => (
                    <span key={index} className="tech-tag">{tag}</span>
                  ))}
                </div>
              </div>
              <a 
                href={`mailto:careers@greenbucks.engineering?subject=Application: ${job.title}`} 
                className="apply-btn"
              >
                Apply Now
              </a>
            </div>
          ))}
        </div>
      </section>

      <section className="section" style={{ background: 'var(--bg-alt)', padding: '4rem 2rem', marginTop: '3rem' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ marginBottom: '1rem' }}>Why Join Greenbucks?</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '2rem', marginTop: '2rem' }}>
            <div>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🚀</div>
              <h4>Growth Opportunities</h4>
              <p style={{ color: 'var(--text-light)', fontSize: '0.95rem' }}>Continuous learning and career development</p>
            </div>
            <div>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🤝</div>
              <h4>Collaborative Culture</h4>
              <p style={{ color: 'var(--text-light)', fontSize: '0.95rem' }}>Work with passionate, talented teammates</p>
            </div>
            <div>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>⚖️</div>
              <h4>Work-Life Balance</h4>
              <p style={{ color: 'var(--text-light)', fontSize: '0.95rem' }}>Flexible hours and remote options</p>
            </div>
            <div>
              <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>💡</div>
              <h4>Innovation First</h4>
              <p style={{ color: 'var(--text-light)', fontSize: '0.95rem' }}>Work on cutting-edge technologies</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Jobs;
